import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ENV } from "../../config/env";
import PdfViewer from "../../components/pdfViewer/PdfViewer";

import AppBreadcrumbs from "../../components/shared/Breadcrumbs/AppBreadcrumbs";
import PageHeader from "../../components/shared/PageHeader/PageHeader";
import DocumentCard from "../../components/shared/Cards/DocumentCard";

import axiosInstance from "../../api/axiosInstance";
import { getCdmpSection, getCdmpDocuments } from "../../api/cdmp";
import DemoNoticeDialog from "../../components/DemoNoticeDialog/DemoNoticeDialog";

const CdmpPage = () => {
  const { section } = useParams();
  const navigate = useNavigate();

  const [page, setPage] = useState(null);
  const [cards, setCards] = useState([]);
  const [openedFromCards, setOpenedFromCards] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

  const handleOpenPdf = async (item, fromCards = true) => {
    console.log("slug", item.slug);

    try {
      const res = await axiosInstance.get(
        `/api/cdmp-documents?filters[slug][$eq]=${item.slug}&populate=*`
      );

      console.log("res----", res);


      const doc = res?.data?.data?.[0];
      if (!doc) {
        console.error("Document not found");
        return;
      }

      // Get PDF URL safely (Strapi compatible)
      const pdfPath =
        doc?.pdfFile?.[0]?.url ||
        doc?.attributes?.pdfFile?.data?.[0]?.attributes?.url;

      if (!pdfPath) {
        console.error("PDF path not found", doc);
        return;
      }

      const fullPdfUrl = ENV.API_BASE_URL + pdfPath;

      // 🔥 FETCH PDF AS BLOB (this fixes preview issue)
      // const pdfResponse = await fetch(fullPdfUrl);
      // const blob = await pdfResponse.blob();

      // // Create local preview URL
      // const blobUrl = URL.createObjectURL(blob);

      setOpenedFromCards(fromCards);

      // Save doc + preview url
      setSelectedDoc({
        ...doc,
        previewUrl: fullPdfUrl,
      });
      // setSelectedDoc({
      //   ...doc,
      //   previewUrl: blobUrl,
      // });
    } catch (error) {
      console.error("Error fetching document:", error);
    }
  };

  // 👇 Back to cards
  const handleBack = () => {
    setSelectedDoc(null);
    setOpenedFromCards(false);
  };

  const downloadPdf = async (pdfUrl, fileName) => {
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "document.pdf";

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  useEffect(() => {
    setCards([]);
    setSelectedDoc(null);
    setPage(null);

    getCdmpSection(section).then((res) => {
      setPage(res.data.data[0]);
    });

    getCdmpDocuments(section).then(async (res) => {
      const docs = res.data.data || [];
      console.log("docs---->", docs)
      if (docs.length === 1) {
        await handleOpenPdf(docs[0], false);
      } else {
        setCards(docs);
      }
    });
  }, [section]);

  if (!page) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: 4, mb: 4 }}>
      <DemoNoticeDialog />

      {/* Breadcrumb */}
      <AppBreadcrumbs
        onParentClick={selectedDoc && openedFromCards ? handleBack : null}
        lastLabel={selectedDoc ? selectedDoc.title : null}
      />
      {/* <AppBreadcrumbs
        onParentClick={selectedDoc && openedFromCards ? handleBack : null}
      /> */}

      {/* 🔥 Dynamic Page Header (ALWAYS RENDER) */}
      {!selectedDoc && (
        <PageHeader
          title={selectedDoc ? selectedDoc.title : page.title}
          description={selectedDoc ? "" : page.description}
        />
      )}

      {/* 🔥 CONTENT SWITCH */}
      {selectedDoc ? (
        // 🟡 PDF VIEW MODE

        <Box sx={{ mt: 3 }}>

          {/* ✅ Show only for /cdmp/documents */}
          {section === "documents" && (
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <button
                onClick={() =>
                  downloadPdf(
                    selectedDoc?.previewUrl,
                    `${selectedDoc?.title || "document"}.pdf`
                  )
                }
                style={{
                  background: "#1976d2",
                  color: "#fff",
                  padding: "10px 18px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Download PDF
              </button>
            </Box>
          )}

          <Box
            sx={{
              width: "100%",
              height: "calc(100vh - 170px)",
              backgroundColor: "#ffffff",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {selectedDoc?.previewUrl ? (
              <PdfViewer fileUrl={selectedDoc.previewUrl} />
            ) : (
              <Typography sx={{ p: 2 }}>
                Loading PDF preview...
              </Typography>
            )}
          </Box>
        </Box>
      ) : (
        // 🟢 CARDS VIEW MODE (DEFAULT)
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          sx={{ mt: 1, px: { xs: 1, md: 0 }, overflowX: "hidden" }}
        >
          {cards.map((item) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={item.id}
              sx={{ display: "flex" }}
            >
              <DocumentCard
                title={item.title}
                description={item.description}
                onDownload={() => handleOpenPdf(item, true)}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default CdmpPage;
